export enum color {
  LEATHER = '#ae6537',
  BLACK = '#000000',
  CLAY_BROWN = '#b67144',
  GREYISH_BROWN = '#573d39',
  WARM_GREY = '#9a8b88',
  DUSTY_ORANGE = '#fe812e',
  DARK_PASTEL_GREEN = '#34d144',
  GREENBLUE = '#21ce98',
  CLEAR_BLUE = '#3479f7',
  VERY_LIGHT_PINK = '#f6f5f4',
  PUTTY = '#b3a79d',
  ORANGEY_RED = '#fe3a2e',
  PINKISH_GREY = '#bcb1b0',
  PALE = '#e5e3e2',
  WHITE = '#ffffff',
  DULL_ORANGE = '#e68027',
}
